import { DynamicAction } from "./dynamic-action.model";
import { DynamicForm } from "./dynamic-form.model";
import { DynamicGrid } from "./dynamic-grid.model";

export class DynamicCrud<T> {

    rightformActions?: Array<DynamicAction>;
    leftformActions?: Array<DynamicAction>;
    crudActions?: Array<DynamicAction>;
    form!: DynamicForm<T>;
    edit?: boolean;
    editTitle?: string;
    addTitle?: string;
    isOpenModal: boolean;
    modalWidth?: number;
    grid?: DynamicGrid<T, T>

    constructor(source: Partial<DynamicCrud<T>>) {
        this.form = new DynamicForm({});
        this.isOpenModal = false;
        this.edit = false;
        this.modalWidth = 70;
        Object.assign(this, source);
    }
}